import { useDispatch } from 'react-redux';
import { initialAuthenicate } from '../../app/user/auth/ducks/auth';
import { useEffect } from 'react';

export default function useInitAuthenticate() {
    const dispatch = useDispatch();
    
    // 인증상태가 아니면 가져온 데이터를 인증으로 처리한다
    useEffect(() => {
        dispatch(initialAuthenicate());  
    }, [dispatch]);
};